export let ResellerHomepageColorType = /*#__PURE__*/function (ResellerHomepageColorType) {
  ResellerHomepageColorType["LIGHT"] = "light";
  ResellerHomepageColorType["DARK"] = "dark";
  return ResellerHomepageColorType;
}({});
export let ResellerHomepageButtonColorType = /*#__PURE__*/function (ResellerHomepageButtonColorType) {
  ResellerHomepageButtonColorType["PRIMARY"] = "primary";
  ResellerHomepageButtonColorType["SECONDARY"] = "secondary";
  return ResellerHomepageButtonColorType;
}({});
export let CuratedBrandStoreRestrictionLevel = /*#__PURE__*/function (CuratedBrandStoreRestrictionLevel) {
  CuratedBrandStoreRestrictionLevel["PUBLIC"] = "PUBLIC";
  CuratedBrandStoreRestrictionLevel["RESTRICTED"] = "RESTRICTED";
  return CuratedBrandStoreRestrictionLevel;
}({});
export let CuratedBrandStoreStatus = /*#__PURE__*/function (CuratedBrandStoreStatus) {
  CuratedBrandStoreStatus["DRAFT"] = "DRAFT";
  CuratedBrandStoreStatus["ACTIVE"] = "ACTIVE";
  return CuratedBrandStoreStatus;
}({});